document.addEventListener("DOMContentLoaded", function () {
  // Vérifier si le bloc search-faq est présent sur la page
  const searchFaqBlock = document.querySelector(".search-faq-block");
  if (!searchFaqBlock) {
    // Si le bloc n'est pas présent, ne pas exécuter le script
    return;
  }

  // Helper function to toggle FAQ item
  function toggleFaqItem(dropdownItem, shouldOpen) {
    const answer = dropdownItem.querySelector(".dropdown-answer");
    const questionWrapper = dropdownItem.querySelector(
      ".dropdown-question-wrapper",
    );

    if (!answer) return;

    if (shouldOpen) {
      dropdownItem.classList.add("active");
      answer.style.display = "flex";
      answer.style.height = "auto";
      if (questionWrapper) {
        questionWrapper.setAttribute("aria-expanded", "true");
      }
    } else {
      dropdownItem.classList.remove("active");
      answer.style.display = "none";
      answer.style.height = "0";
      if (questionWrapper) {
        questionWrapper.setAttribute("aria-expanded", "false");
      }
    }
  }

  // FAQ accordion - use delegation on container to handle dynamic content
  const faqContainer = document.getElementById("faq-items-container");
  if (faqContainer) {
    faqContainer.addEventListener("click", function (e) {
      const questionWrapper = e.target.closest(".dropdown-question-wrapper");
      if (questionWrapper) {
        e.preventDefault();
        e.stopPropagation();

        const dropdownItem = questionWrapper.closest(".dropdown-item");
        const answer = dropdownItem.querySelector(".dropdown-answer");

        // Check if open by looking at the actual display style, not the class
        const isOpen =
          answer &&
          (answer.style.display === "flex" || answer.style.display === "");

        // Toggle using the helper function
        toggleFaqItem(dropdownItem, !isOpen);
      }
    });
  }

  // Initialize FAQ items - ensure all are closed on page load, except the first one
  setTimeout(function () {
    const initialFaqItems = document.querySelectorAll(".dropdown-item");
    initialFaqItems.forEach((item) => {
      toggleFaqItem(item, false);
    });
    if (initialFaqItems.length > 0) {
      toggleFaqItem(initialFaqItems[0], true);
    }
  }, 100);

  // Parent Category Accordion functionality - improved for mobile
  const parentAccordionBtns = document.querySelectorAll(
    ".faq-parent-accordion-btn",
  );

  function handleParentAccordionClick(btn) {
    const parentGroup = btn.closest(".faq-parent-group");
    const subList = parentGroup.querySelector(".faq-sub-categories-list");
    const icon = btn.querySelector(".faq-parent-icon");
    const isActive = parentGroup.classList.contains("active");

    if (isActive) {
      // Close this parent category
      parentGroup.classList.remove("active");
      subList.style.maxHeight = "0";
      subList.style.opacity = "0";
      icon.classList.add("rotate-180");
    } else {
      // Close all other parent categories (mobile behavior)
      const allParentGroups = document.querySelectorAll(".faq-parent-group");
      allParentGroups.forEach((group) => {
        if (group !== parentGroup) {
          const otherSubList = group.querySelector(".faq-sub-categories-list");
          const otherIcon = group.querySelector(".faq-parent-icon");
          group.classList.remove("active");
          if (otherSubList) {
            otherSubList.style.maxHeight = "0";
            otherSubList.style.opacity = "0";
          }
          if (otherIcon) {
            otherIcon.classList.add("rotate-180");
          }
        }
      });

      // Open this parent category
      parentGroup.classList.add("active");
      subList.style.maxHeight = subList.scrollHeight + "px";
      subList.style.opacity = "1";
      icon.classList.remove("rotate-180");
    }
  }

  parentAccordionBtns.forEach((btn) => {
    // Handle both click and touch events
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      handleParentAccordionClick(this);
    });

    btn.addEventListener("touchend", function (e) {
      e.preventDefault();
      handleParentAccordionClick(this);
    });
  });

  // Search functionality - improved to work with dynamic content
  const searchInput = document.getElementById("faq-search-input");
  const searchButton = document.querySelector(".search-faq-button");

  function performSearch() {
    const searchTerm = searchInput.value.toLowerCase().trim();
    const faqItems = document.querySelectorAll(".dropdown-item");
    let visibleCount = 0;

    faqItems.forEach((item) => {
      const title = item.getAttribute("data-faq-title") || "";
      const content =
        item.querySelector(".dropdown-answer")?.textContent.toLowerCase() || "";

      // Search in both title and content
      if (title.includes(searchTerm) || content.includes(searchTerm)) {
        item.style.display = "block";
        visibleCount++;
      } else {
        item.style.display = "none";
      }
    });

    // Show message if no results
    const container = document.getElementById("faq-items-container");
    let noResultsMsg = container.querySelector(".no-results-message");

    if (visibleCount === 0 && searchTerm !== "") {
      if (!noResultsMsg) {
        noResultsMsg = document.createElement("p");
        noResultsMsg.className =
          "no-results-message text-center text-gray-500 py-4";
        noResultsMsg.textContent =
          "Aucun résultat trouvé pour votre recherche.";
        container.appendChild(noResultsMsg);
      }
      noResultsMsg.style.display = "block";
    } else if (noResultsMsg) {
      noResultsMsg.style.display = "none";
    }
  }

  if (searchInput) {
    searchInput.addEventListener("input", performSearch);
    searchInput.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        performSearch();
      }
    });
  }

  if (searchButton) {
    searchButton.addEventListener("click", function (e) {
      e.preventDefault();
      performSearch();
    });
  }

  // Subcategory filter - improved for mobile devices
  const subCategoryBtns = document.querySelectorAll(".faq-sub-category-btn");

  function handleSubCategoryClick(btn) {
    const parentColor = btn.getAttribute("data-parent-color");

    // Remove active class from all buttons and reset colors
    subCategoryBtns.forEach((b) => {
      const originalColor = b.getAttribute("data-parent-color");
      b.classList.remove("active");
      b.classList.remove("text-white");
      b.classList.add("text-gray-700");
      b.style.backgroundColor = "";
      // Remettre la variable CSS pour le hover
      b.style.setProperty("--hover-color", originalColor);

      // Reset icon color
      const icon = b.querySelector(".faq-sub-icon");
      if (icon) {
        icon.style.color = originalColor;
      }

      // Reset name color
      const name = b.querySelector(".faq-sub-name");
      if (name) {
        name.style.color = "";
      }
    });

    // Add active class to clicked button with parent color
    btn.classList.add("active");
    btn.classList.add("text-white");
    btn.classList.remove("text-gray-700");
    btn.style.backgroundColor = parentColor;

    // Set icon to white
    const activeIcon = btn.querySelector(".faq-sub-icon");
    if (activeIcon) {
      activeIcon.style.color = "white";
    }

    // Set name to white
    const activeName = btn.querySelector(".faq-sub-name");
    if (activeName) {
      activeName.style.color = "white";
    }

    // Clear search when changing category
    if (searchInput) {
      searchInput.value = "";
    }

    // Load FAQs for this subcategory via AJAX
    const subCatId = btn.getAttribute("data-subcategory-id");
    loadFaqsBySubcategory(subCatId);

    // Scroll to FAQ content area on mobile/tablet
    const faqContentArea = document.querySelector(".faq-content-area");
    if (faqContentArea && window.innerWidth < 1024) {
      setTimeout(() => {
        faqContentArea.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }

  subCategoryBtns.forEach((btn) => {
    // Handle both click and touch events for better mobile support
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleSubCategoryClick(this);
    });

    // Add touch event for mobile devices
    btn.addEventListener("touchend", function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleSubCategoryClick(this);
    });
  });

  // Load FAQs by subcategory
  function loadFaqsBySubcategory(subCatId) {
    const container = document.getElementById("faq-items-container");

    if (!container) {
      console.error("FAQ container not found");
      return;
    }

    console.log("Loading FAQs for subcategory:", subCatId);
    console.log("Window location:", window.location.href);
    console.log(
      "faqAjax object:",
      typeof faqAjax !== "undefined" ? faqAjax : "undefined",
    );
    console.log(
      "ajax object:",
      typeof ajax !== "undefined" ? ajax : "undefined",
    );

    container.innerHTML =
      '<p class="text-center text-gray-500">Chargement...</p>';

    // Construct absolute AJAX URL to avoid relative path issues on mobile
    let ajaxUrl;
    if (typeof faqAjax !== "undefined" && faqAjax.url) {
      ajaxUrl = faqAjax.url;
      console.log("Using faqAjax.url");
    } else if (typeof ajax !== "undefined" && ajax.url) {
      ajaxUrl = ajax.url;
      console.log("Using ajax.url");
    } else {
      // Fallback: construct absolute URL from current location
      const protocol = window.location.protocol;
      const host = window.location.host;
      ajaxUrl = protocol + "//" + host + "/wp-admin/admin-ajax.php";
      console.log("Using fallback URL");
    }

    const url =
      ajaxUrl +
      "?action=load_faqs_by_subcategory&subcategory_id=" +
      encodeURIComponent(subCatId);

    console.log("Final AJAX URL:", url);
    console.log("Subcategory ID:", subCatId, "Type:", typeof subCatId);

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    })
      .then((response) => {
        console.log("Response status:", response.status);
        if (!response.ok) {
          throw new Error("Network response was not ok: " + response.status);
        }
        return response.json();
      })
      .then((data) => {
        console.log("AJAX response data:", data);
        if (data.success) {
          container.innerHTML = data.data.html;
          // Re-initialize first FAQ item as open after loading new content
          const newFaqItems = container.querySelectorAll(".dropdown-item");
          newFaqItems.forEach((item, index) => {
            toggleFaqItem(item, index === 0);
          });
          console.log("FAQs loaded successfully, count:", newFaqItems.length);
        } else {
          console.warn("AJAX returned success:false", data);
          container.innerHTML =
            '<p class="text-center text-gray-500">Aucune FAQ disponible pour cette catégorie.</p>';
        }
      })
      .catch((error) => {
        console.error("Error loading FAQs:", error);
        container.innerHTML =
          '<p class="text-center text-red-500">Erreur de chargement: ' +
          error.message +
          "</p>";
      });
  }
});
